var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "945px",
    height: "945px",
    viewBox: "0 0 945 945",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CheckShadow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckShadow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.514508929
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.544196,582 C706.057158,582 719.640083,585.032414 729.844768,591.041322 C733.522853,593.209434 736.591255,595.590433 739,598.105835 L738.786,598.125 L738.980558,598.331366 C749.108893,609.291287 746.932101,622.690279 728.810372,632.254062 C719.001017,637.425944 706.573829,640 694.11655,640 C680.52588,639.99901 666.90512,636.935695 656.604295,630.836796 C645.380709,624.194166 640.646542,615.378593 642.331584,606.978989 L643.018,606.914 L643.074334,606.648875 C644.454952,600.450277 649.407218,594.502325 657.912233,589.86799 C667.55721,584.60664 680.020718,582 692.544196,582 Z",
    id: "Check-Shadow",
    fill: "#94A4E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckShadow);
export default __webpack_public_path__ + "static/media/CheckShadow.fe7a9bc62d65062d8bf34fdcc90d2428.svg";
export { ForwardRef as ReactComponent };